import { render } from "./FailedDeliveryCsvReport.vue?vue&type=template&id=6fb3ee04&ts=true&lang=pug"
import script from "./FailedDeliveryCsvReport.vue?vue&type=script&lang=ts"
export * from "./FailedDeliveryCsvReport.vue?vue&type=script&lang=ts"

import "./FailedDeliveryCsvReport.vue?vue&type=style&index=0&id=6fb3ee04&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__